import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { LeadModalComponent } from '@shared/components/lead-modal/lead-modal.component';
import { AdminService } from '@core/services/admin.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    LeadModalComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'Fresply — B2B Perishables & Seafood Commodity Platform';

  constructor(public adminService: AdminService) {}
}

